// extracted by mini-css-extract-plugin
export default {"container":"InviteInput_container__TuDrQ"};